import React from "react";
import { Switch, Route } from "react-router-dom";

// Components
import LinkedTitle from "../../utils/titles/LinkedTitle";
import NewsSearch from "./NewsSearch";
import AdminNewsForm from "./AdminNewsForm";

class AdminNewsEdit extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				<LinkedTitle link={{ href: "/admin/news/add", title: "Create" }}>
					Edit News
				</LinkedTitle>

				<Switch>
					<Route path={"/admin/news"} exact component={NewsSearch} />
					<Route path={"/admin/news/edit"} exact component={NewsSearch} />
					<Route path={"/admin/news/edit/:id"} component={AdminNewsForm} />
				</Switch>
			</React.Fragment>
		);
	}
}

export default AdminNewsEdit;



// WEBPACK FOOTER //
// ./src/components/admin/news/AdminNewsEdit.js